// import Vue from 'vue';
import http from '../../utils/http/request';
import { Message } from 'ant-design-vue';
import router from '../../router/index';
/**
 * @function beforeSend  http请求前拦截器
 */
/* eslint-disable */
const beforeSend = (res) => {
    //www.lyswb.cn/api/v1/

    https: return true;
};
/**
 * @function 响应拦截器
 * @param  {type} res {接口相应数据}
 */
const interceptorSuccess = (res) => {
    return true;
    // }
};
const interceptError = (res) => {
    if (res.Code === 555 || res.Code === 666) {
        return false;
    }
    console.log(res);
    var response = res.response;

    if (
        res.response.status === 400 ||
        res.response.status === 401 ||
        res.response.status === 403 ||
        res.response.status === 419 ||
        res.response.status === 420 ||
        res.response.status === 422 ||
        res.response.status === 429 ||
        res.response.status === 500
    ) {
        var k = null;
        switch (res.response.status) {
            case 401:
                router.push({ name: 'login' });
                break;
            case 422:
                k = Object.keys(response.data.errors)[0];

                Message.error(response.data.errors[k][0]);
                break;
            case 500:
                // Message.error('系统异常');
                422;
            case 429:
                k = Object.keys(response.data.errors)[0];

                Message.error(response.data.errors[k][0]);
                break;
            case 400:
                // Message.error(response.data.message);
                break;
            case 403:
                // Message.error('暂无权限');
                break;
            default:
                break;
        }
        return false;
    }
};

export const defaultFunc = {
    requestInterceptor: beforeSend,
    interceptorSuccess: interceptorSuccess,
    interceptError: interceptError
};
